<template>
  <div class="header">
    <el-row class="center_box">
      <el-col :span="4">
        <div
          @click="indexfunc"
          style="cursor: pointer"
          class="grid-content left"
        >
          <!-- <div class="title_max">活动云平台</div>
                    <div class="name_small">Activity cloud platform</div> -->
          <img class="logoImg" src="@/assets/images/logo.png" />
        </div>
      </el-col>

      <el-col v-if="isShow" :span="12" class="search_header">
        <div class="grid-content bg-purple-light">
          <el-input
            v-model="searchInput"
            placeholder="请输入活动名称、机构名称(主办方、参赛机构)"
          ></el-input>
          <el-button
            class="searchBtn"
            @click="activityList"
            icon="el-icon-search"
            >搜索</el-button
          >
        </div>
      </el-col>

      <el-col v-if="isShow" :span="3" class="search_header">
        <el-link href="https://www.yulin365.net/manage" :underline="false">
          <div class="grid-content bg-purple-light">
            <el-button class="beginHd" icon="el-icon-position"
              >我要办活动</el-button
            >
          </div>
        </el-link>
      </el-col>

      <!-- 导航开始 -->
      <!-- <el-col v-if='isShow' :span="15"><div class="grid-content bg-purple-light">
                <el-menu
                    :default-active="activeIndex"
                    class="el-menu-demo"
                    mode="horizontal"
                    @select="handleSelect"
                    active-text-color="#3370ff"
                    >
                    <el-menu-item index="1" >首页</el-menu-item>
                </el-menu>
            </div></el-col> -->

      <!-- 登录后状态 -->
      <el-col :span="5" v-if="is_login && isShow">
        <div class="rights">
          <!-- <span></span>&nbsp;&nbsp;&nbsp; -->
          <router-link to="/message">
            <i class="el-icon-bell"
              ><label v-if="hasMessage == 1"></label
            ></i> </router-link
          >&nbsp;&nbsp;
          <router-link to="/my" class="horizon">
            <img
              class="txImg"
              :src="user.head_portrait"
              :onerror="defaultImg"
            />
            <el-link class="username" :underline="false" target="_blank">{{
              user.username
            }}</el-link> </router-link
          >&nbsp;&nbsp; <span></span>&nbsp;&nbsp;
          <router-link to="">
            <el-link :underline="false" target="_blank" @click="logout"
              >退出</el-link
            >
          </router-link>
        </div>
      </el-col>
      <el-col :span="5" v-else-if="isShow">
        <div class="rights">
          <router-link to="/login">
            <el-link :underline="false" target="_blank"
              >登录</el-link
            > </router-link
          >&nbsp;&nbsp;&nbsp;&nbsp; <span></span>&nbsp;&nbsp;&nbsp;&nbsp;
          <router-link to="/register">
            <el-link :underline="false" target="_blank">注册</el-link>
          </router-link>
        </div>
      </el-col>
    </el-row>

    <div class="tabsIndex" v-if="isShow">
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="首页" name="first"></el-tab-pane>
                <el-tab-pane label="个人中心" name="second"></el-tab-pane>
            </el-tabs> -->
      <el-col v-if="isShow" :span="15"
        ><div class="grid-content bg-purple-light">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            active-text-color="#3370ff"
          >
            <el-menu-item index="1">首页</el-menu-item>
            <!--                    <el-menu-item index="3" >视频讲堂</el-menu-item>-->
            <!--                    <el-menu-item index="4" >有知</el-menu-item>-->
            <!--                    <el-menu-item index="5" >青青写</el-menu-item>-->
            <!--                    <el-menu-item index="6" >深度阅读</el-menu-item>-->
            <!--                    <el-menu-item index="7" >青青写</el-menu-item>-->

            <el-menu-item
              :index="item.title"
              v-for="(item, index) in menuList"
              :key="index"
              >{{ item.title }}</el-menu-item
            >
            <el-menu-item index="2">个人中心</el-menu-item>
          </el-menu>
        </div></el-col
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeHeader",
  props: ["isShow", "activeIndex", "hasMessage"],
  data() {
    return {
      is_login: false,
      has_message: "",
      searchInput: "",
      user: {},
      activeName: "first",
      menuList: [],
    };
  },
  computed: {
    defaultImg() {
      return 'this.src="' + require("@/assets/images/headerImg.jpg") + '"';
    },
  },

  created() {
    //   this.getUser()
    this.getUserbylocal();
    this.getInputValue();
    this.getMenu();
  },
  methods: {
    getUser() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      let token = sessionStorage.getItem("token");
      // console.log(user)
      if (token) {
        this.$data.is_login = true;
      }
      if (user) {
        this.$data.user = user;
      }
    },

    getUserbylocal() {
      let user = JSON.parse(localStorage.getItem("user"));
      let token = localStorage.getItem("token");
      // console.log(user)
      if (token) {
        this.$data.is_login = true;
      }
      if (user) {
        this.$data.user = user;
      }
    },
    

    getInputValue() {
      let keyWord = this.$route.params.keyword;
      //    console.log(keyWord,"头部")
      if (keyWord == "undefined") {
        this.searchInput = "";
      } else {
        this.searchInput = keyWord;
      }
    },

    setInputValue() {
      this.searchInput = "";
    },

    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      if (key == 1) {
        this.$router.replace("/");
      } else if (key == 2) {
        this.$router.replace("/my");
      } else if (key == "视频讲堂") {
        this.$router.replace("/videonote");
      } else if (key == "有知") {
        this.$router.replace("/knowing");
      } else if (key == "青青写") {
        this.$router.replace("/greenwrite");
      } else if (key == "深度阅读") {
        this.$router.replace("/deepread");
      } else if (key == "青青听") {
        this.$router.replace("/greenlisten");
      }

      // if(key == 1){
      //     this.$router.replace('/')
      // }else if(key == 2){
      //     this.$router.replace('/my')
      // }else if(key == 3){
      //     this.$router.replace('/videonote')
      // }else if (key == 4){
      //     this.$router.replace('/knowing')
      // }else if(key==7){
      //     this.$router.replace('/greenwrite')
      // }else if(key==6){
      //     this.$router.replace('/deepread')
      // }else if(key == 5){
      //     this.$router.replace('/greenlisten')
      // }
    },

    activityList() {
      var keyword = this.searchInput;
      if (keyword == "") {
        this.$router.replace("/activity/undefined");
      } else {
        this.$router.replace("/activity/" + keyword);
      }
      this.$emit("func", this.searchInput);
    },

    indexfunc() {
      this.$router.replace("/");
    },
    logout() {
      this.$api
        .logout()
        .then((res) => {
          //数据处理
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("user");
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          this.$router.replace({
            path: "/login",
          });
        })
        .catch((err) => console.log(err));
    },

    getMenu() {
      let ogran_id = this.getOgranId();
      this.$api
        .getExpendMenu({
          data: {
            ogran_id: ogran_id,
          },
          params: {},
        })
        .then((res) => {
          // this.menuList = res.data;
          let list = [];
          for (let el of res.data) {
            if (el.title != "开心") {
              list.push(el);
            }
          }
          this.menuList = list;
        });
    },
    //
    getOgranId() {
      let ogran_id = "";
      if (this.$route.name == "Index") {
        ogran_id = this.$route.params.id;
        if (ogran_id) {
          localStorage.setItem("ogran_id", ogran_id);
        }
      }else {
          ogran_id = localStorage.getItem('ogran_id');
      }
      return ogran_id;
    },
  },
};
</script>
<style  scoped>
/* 搜索部分样式 */
.search_header {
  display: flex;
  align-items: center;
  justify-content: center;
}

.search_header .grid-content >>> .el-input__inner {
  width: 378px;
  height: 38px;
  border: 2px solid #3370ff;
  border-radius: 20px 0px 0px 20px;
  box-sizing: border-box;
}
.search_header .grid-content >>> .searchBtn {
  width: 100px;
  height: 40px;
  text-align: center;
  background: #3370ff;
  color: white;
  border-radius: 0px 20px 20px 0px;
  margin-left: -13px;
}
.search_header .grid-content >>> .beginHd {
  width: 129px;
  height: 40px;
  background: #3370ff;
  border-radius: 20px;
  color: white;
  padding: 0px 5px;
  box-sizing: border-box;
}

/* tab样式 */
.tabsIndex {
  width: 1920px;
  height: 54px;
  background: #3370ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tabsIndex >>> .el-menu {
  width: 1200px;
  height: 54px;
  background: #3370ff;
}
.tabsIndex >>> .el-tabs__nav-wrap::after {
  background: none;
}
.tabsIndex >>> .el-tabs__item.is-active {
  background: #53a556;
}
.tabsIndex >>> .el-tabs__item:hover {
  background: #53a556;
}

.header {
  width: 1920px;
  height: auto;
  background: #ffffff;
  /* border-bottom: 10px solid #FFB463; */
}
.center_box {
  width: 1200px;
  margin: 0 auto;
}
.left {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-icon-bell {
  font-size: 18px;
  color: #3370ff;
  position: relative;
  margin-right: 10px;
}
.el-icon-bell label {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 2.5px;
  background: red;
  position: absolute;
  right: -3px;
  top: -3px;
}

.logoImg {
  width: 166px;
  height: 60px;
}
.center_box .el-col {
  height: 126px;
}

.tabsIndex >>> .el-row {
  height: 54px;
}
.el-menu--horizontal > .el-menu-item {
  border-bottom: none;
  height: 54px;
  color: white;
}
.tabsIndex >>> .el-menu--horizontal > .el-menu-item:hover {
  background: #53a556 !important;
  color: white !important;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
  background: #53a556;
  color: white;
}
.grid-content {
  display: flex;
  align-items: center;
}
.rights {
  width: auto;
  height: 126px;
  display: flex;
  align-items: center;
  align-content: flex-end;
  justify-content: center !important;
}
.rights .txImg {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin-right: 15px;
}
.username {
  display: table;
  max-width: 90px;
  text-align: center;
}
.left {
  height: 126px;
  flex-direction: column;
  align-items: flex-end !important;
  padding-right: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title_max {
  width: 200px;
  height: 80px;
  font-size: 35px;
  display: flex;
  align-items: center;
  font-family: Alibaba PuHuiTi;
  font-weight: bold;
  color: #3370ff;
  justify-content: center;
}
.name_small {
  width: 200px;
  height: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3370ff;
  text-align: center;
}
.el-menu-demo {
  width: 500px;
}
.el-menu-item {
  width: 150px;
  text-align: center;
  font-size: 16px;
  color: white;
}
.el-menu {
  border-bottom: none;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
  background: #53a556;
  color: white !important;
}
.el-menu--horizontal > .el-menu-item:hover {
  border-bottom: none;
  background: #53a556;
  color: white !important;
}
.el-link--inner {
  width: 29px;
  height: 14px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-right: 50px !important;
}
span {
  display: inline-table;
  width: 2px;
  height: 17px;
  background: #999999;
}
.horizon {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue